// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__MXn04","col":"styles_col__3WZsy"};